import pmangStyles from '../styles/footer.scss';
import daumStyles from '../styles/footer-daum.scss';
import pmangFooter from './footer-template.hbs';
import daumFooter from './footer-daum-template.hbs';

export interface IFooterOptions {
  type: string; // fluid | wide | narrow | daum | kakao
  placeholder?: HTMLElement | string | null;
  width?: number | null;
  marginTop?: number | null;
  topBorder?: boolean;
  showExtra?: boolean;
  background?: string;
  simple?: boolean;
}

let wrapper: HTMLElement | undefined;

const defaultOptions: IFooterOptions = {
  type: 'wide',
  placeholder: null,
  width: null,
  marginTop: 50,
  topBorder: true,
  showExtra: true,
  background: '#fff',
  simple: false
};

export function renderFooter(options?: string | IFooterOptions): void {
  // prettier-ignore
  const currentOptions = typeof options === 'string'
      ? {
          ...defaultOptions,
          type: options
        }
      : {
          ...defaultOptions,
          ...options
        };

  const isDaum = /^(daum|kakao)$/.test(currentOptions.type);
  const tpl = isDaum ? daumFooter : pmangFooter;
  const styles = isDaum ? daumStyles : pmangStyles;

  const rendered = tpl.render({
    styles,
    width: currentOptions.width,
    footerType: (styles as any)[currentOptions.type],
    simple: Boolean(currentOptions.simple),
    // eslint-disable-next-line no-unneeded-ternary
    showExtra: currentOptions.showExtra
  });

  const hideBorder = !currentOptions.topBorder;
  const marginTop = currentOptions.marginTop ?? 0;

  if (wrapper && wrapper.parentNode) {
    wrapper.parentNode.removeChild(wrapper);
  }

  wrapper = document.createElement('div');
  wrapper.className = styles.wrapper;

  if (hideBorder) {
    wrapper.style.borderTop = 'none';
  }

  if (marginTop > 0) {
    wrapper.style.marginTop = `${marginTop}px`;
  }

  wrapper.style.background = currentOptions.background ?? '';

  wrapper.innerHTML = rendered;

  if (!currentOptions.placeholder) {
    document.body.appendChild(wrapper);
  } else if (currentOptions.placeholder instanceof HTMLElement) {
    currentOptions.placeholder.appendChild(wrapper);
  } else if (typeof currentOptions.placeholder === 'string') {
    const el = document.querySelector(currentOptions.placeholder);
    if (el) {
      el.appendChild(wrapper);
    }
  }
}
